import { render, staticRenderFns } from "./MarketingStatistics.vue?vue&type=template&id=6496a457&scoped=true"
import script from "./MarketingStatistics.vue?vue&type=script&lang=ts"
export * from "./MarketingStatistics.vue?vue&type=script&lang=ts"
import style0 from "./MarketingStatistics.vue?vue&type=style&index=0&id=6496a457&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6496a457",
  null
  
)

export default component.exports